<template>
    <q-page padding class="docs-input row justify-center divimage">
        <div class="auth shadow-10">
            <div class = "q-ma-md" align="center">
                <p class="caption" >{{$t('authtitle')}}</p>
                <q-field :label="$t('loginph')" style="font-size:10pt;" :label-width="3">
                    <q-input 
                        v-model="form.login" 
                        style="text-align:left;"
                        :error="$v.form.login.$error"
                        prefix="+7"
                        maxlength="15"
                    />
                </q-field>
                <q-field :label="$t('passph')" style="font-size:10pt;" :label-width="3">
                    <q-input 
                        type="password" 
                        v-model="form.password" 
                        @keyup.enter="submit" 
                        style="text-align:left;"
                        :error="$v.form.password.$error"
                    />
                </q-field>
                <q-btn color="primary" class = "q-ma-lg" @click="submit">{{$t('enter')}}</q-btn>
            </div>
        </div>
    </q-page>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import axios from 'axios'
import VMasker from 'vanilla-masker'

export default {
    data () {
        return {
            form: {
                login: '',
                password: ''
            }
        }
    },
    validations: {
        form: {
            login: { required },
            password: { required }
        }
    },

    watch: {
        'form.login' (newVal) {
            this.form.login = VMasker.toPattern(newVal, '(999) 999-99-99')
        }
    },  

    methods: {
        submit () {
            this.$v.form.$touch()
            if (this.$v.form.login.$error) {
                this.$q.notify({
                    message: this.$t('emptylogin'),
                    type: 'negative',
                    icon: 'report_problem'
                })
                return
            }
            if (this.$v.form.password.$error) {
                this.$q.notify({
                    message: this.$t('emptypass'),
                    type: 'negative',
                    icon: 'report_problem'
                })
                return
            }
            var request = {
                phone: '+7' + this.form.login.replace(/\D+/g, ''),
                password: this.form.password
            }
            const requestStr = JSON.stringify(request)
            axios.post(this.$root.api_url + 'token/',  requestStr, {
                headers: {
                    'Content-Type': 'application/json'
                }
            })
            .then((response) => {
            //console.log(response)
                this.$store.commit('set_token', response.data)
                this.$store.commit('set_auth')
                this.$q.notify({
                    message: this.$t('welcome'),
                    type: 'positive',
                    icon: 'thumb_up'
                })
                axios.get (this.$root.api_url + 'user/me/', {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'JWT ' + this.$store.state.token                
                    }
                    })  
                    .then((data) => {
                        this.$store.commit('set_name', data.data.name)
                    })
                    .catch(() => {
                        this.$q.notify({
                            message: this.$t('errors.regerr'),
                            type: 'negative',
                            icon: 'report_problem'
                        })
                    })
                this.$router.push('/devices')
            })
            .catch(() => {
                this.$q.notify({
                    message: this.$t('autherr'),
                    type: 'negative',
                    icon: 'report_problem'
                })
            })
        }
    }
}
</script>

<style scoped>
.divimage{
    background-image: url('../assets/background.jpg');
    background-repeat: repeat-y; /* for vertical repeat */
    background-repeat: repeat-x; /* for horizontal repeat */
    background-size: 100%;
}

.auth{
    background-color: white;
    border: 1px solid green;
    width: 500px; 
    height: 200px;
    border-radius: 5px;
    position: absolute;
    top: 35%;    
}


</style>

